import { render, staticRenderFns } from "./platform-usps.vue?vue&type=template&id=0e789494&scoped=true"
import script from "./platform-usps.vue?vue&type=script&lang=js"
export * from "./platform-usps.vue?vue&type=script&lang=js"
import style0 from "./platform-usps.vue?vue&type=style&index=0&id=0e789494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e789494",
  null
  
)

export default component.exports